import { createAction } from 'redux-actions'

const SAVE_TOKEN_DETAILS = 'SAVE_TOKEN_DETAILS'

export const saveTokenDetails = createAction(SAVE_TOKEN_DETAILS)
